import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../localization/labels";
import ClassificationService from "../../../../services/ClassificationService";
import PartySubscriptionService from "../../../../services/PartySubscriptionService";
import PartySession from "../../../../session/PartySession";
import { constants } from "../../../../utils/Constants";
import SecurityUtils from "../../../../utils/SecurityUtils";
import SubControlComponent from "../../page/SubControlComponent";
import ClassificationPartySubscriptions from "./ClassificationPartySubscriptions";

class ClassificationPartySubscriptionsContainer extends SubControlComponent {
  constructor(props) {
    super(props);

    this.classificationService = new ClassificationService(this.keycloak);
    this.partySubscriptionService = new PartySubscriptionService(this.keycloak);

    this.state = this.initialState();
  }

  componentDidMount() {
    super.componentDidMount();
    this.prepareCall(
      this.partySubscriptionService.getEntitiesByUrl(
        PartySession.getParty()?._links.partySubscription.href,
        this.onPartySubscriptionLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  }

  onPartySubscriptionLoad = data => {
    this.resetFlags = this.setResetFlags(true);

    this.setState({
      entity: { ...data },
      oldEntity: { ...data },
      classificationsFilter: SecurityUtils.geClassificationsByOperation(
        constants.OPERATION_READ
      )
    });
  };

  getSubArraysPaths = () => {
    return ["classifications"];
  };

  updateEntity = entity => {
    this.prepareCall(
      this.partySubscriptionService.patchEntity(
        entity,
        this.state.oldEntity,
        this.onPartySubscriptionLoad,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage,
        undefined,
        ["/classifications/\\d+/leaf", ".*/_links"]
      )
    );

    this.performCalls();
  };

  getComponentTitle = () => {
    return labels.classificationSubscriptions;
  };

  render() {
    return (
      <ClassificationPartySubscriptions
        {...this.handlerProps()}
        onSave={this.onEntitySave}
        entity={this.state.entity}
        setClassificationsOnEntity={classifications =>
          this.setEntityProperty(this.getSubArraysPaths()[0], classifications)
        }
        setInitialEntityPropertyState={(propertyName, propertyValue) =>
          this.setEntityProperty(propertyName, propertyValue, true)
        }
        classificationsFilter={this.state.classificationsFilter}
      />
    );
  }
}

export default withKeycloak(ClassificationPartySubscriptionsContainer);
